import React, { useEffect, useMemo, useState } from 'react';
import { Layout, Col, Row } from 'tea-component';
import { FilterFixed, useFilterDataHook } from '../../components/FilterCommon';
import ContentBody from '../../components/ContentBody';
import { connect } from 'umi';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import performancePoint from '@op/operationLog/pages/performance';
import CardCommon from '@op/components/CardCommon';
const { Content } = Layout;

function FilterPage({ gameInfo }: any) {
  useInitBuriedPointInfo({
    buriedPoint: performancePoint,
    triggerPagePoint: false,
  });
  const {
    scrollBody,
    loading,
    filter,
    changeFilter,
    filterOptions,
    initState,
  } = useFilterDataHook({ gameInfo, pageName: 'Filter_Page' });

  return (
    <Content className="dbo-page dbo-performance" ref={scrollBody}>
      <ContentBody
        contentHeard={
          <Content.Header
            className="dbo-header"
            title={'Filter'}
          ></Content.Header>
        }
      >
        <FilterFixed
          scrollBody={scrollBody}
          filter={filterOptions}
          confirm={(value: any) => {
            changeFilter(value);
          }}
        ></FilterFixed>

        <CardCommon>
          这个是过滤器测试页面，因为集合了所有的过滤器数据，部分过滤器冲突，可能会导致组件错误
          其中比较明显的是语言过滤器,可能会污染缓存数据，如果出现了报错，可以进行清理缓存
        </CardCommon>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { opinionCommon, opinionFilter } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    filter: opinionFilter,
  };
})(FilterPage);
